import 'globals';

(function($, window) {
	var viewport = {},
		breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'],
		ranges = {
			'xs': 0,
			'sm': 576,
			'md': 768,
			'lg': 992,
			'xl': 1200
		};

	$.each(breakpoints, function(i, val) {
		viewport[val] = {};

		if (i > 0) {
			viewport[val].up = true;

			if ('matchMedia' in window) {
				var from = ranges[val],
					mqUp = matchMedia('(min-width: ' + from + 'px)');

				viewport[val].up = mqUp.matches;
				mqUp.addListener(function(mq) {
					viewport[val].up = mq.matches;
				});
			}
		}

		if (i + 1 < breakpoints.length) {
			viewport[val].down = true;

			if ('matchMedia' in window) {
				var next = breakpoints[i + 1],
					to = ranges[next] - 1,
					mqDown = matchMedia('(max-width: ' + to + 'px)');

				viewport[val].down = mqDown.matches;
				mqDown.addListener(function(mq) {
					viewport[val].down = mq.matches;
				});
			}
		}
	});

	window.viewport = viewport;
})(jQuery, window);
